
import './../styles/home.css';

const  Home = () => {
  return (
    <div className="app">
      <div className="home">
        <p className="text-home">
        <br/><br/>
        Go Developer (Fullstack | React/React Native)<br/>
        I create fast backends and user-friendly interfaces — from server to mobile app<br/><br/>

        🔧 Tech stack: <br/>
        Backend: Go (Gin, Echo, gRPC), PostgreSQL, ClickHouse, Redis, RabbitMQ, Kafka, MQTT, ffmpeg, Docker <br/>
        Frontend: React, VUE  <br/>
        Mobile: React Native (Expo, native modules)  <br/> <br/>

        💡 What will I bring to your project? <br/>
        ✔ Go backend that won't break under load - optimized API, efficient data handling, smart caching <br/>
        ✔ Frontend that you won't be ashamed to show to the client - neat UI, fast loading, well-thought-out logic <br/>
        ✔ Mobile application without crutches - stable, with smooth UX and synchronization with the backend  <br/>
        Full development cycle - from technical specifications to deployment and monitoring  <br/>
        </p>
      </div> 
    </div>
)}

export default Home;